module.exports = __webpack_public_path__ + "static/img/video_ranking_list_top3.fef9fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_ranking_list_top3.png
// module id = XQ74
// module chunks = 1